import React, { useContext, useMemo } from "react";

import { Button } from "../../../../components/Button";
import { Headline } from "../../../../components/Headline";
import { Image } from "../../../../components/Image";

import CameraComparisonContext from "../CameraComparisonContext";

import t from "../../../../lib/translate";

import * as styles from "./cameraGeneralInformation.module.less";

export function CameraGeneralInformation({ id, name, image }) {
    const { removeCamera } = useContext(
        CameraComparisonContext
    );

    return (
        <td>
            <Image
                objectFit="cover"
                objectPosition="50% 50%"
                className={styles.image}
                image={image}
            />

            <Headline semanticOfHeadline={"H5 Style"} headlineClass={styles.h5}>
                {name}
            </Headline>

            <Button
                type="secondary"
                icon="close"
                iconPosition="left"
                onClick={() => removeCamera(id)}
                className={styles.removeCamera}
            >
                {t("camera.compare.delete.button")}
            </Button>
        </td>
    );
}
